import {Observable} from 'rxjs';
import type {ActionsObservable} from 'redux-observable';
import {switchMap, map, catchError} from 'rxjs/operators';

import type {UsersApiResponse} from '../types';
import {fetch as fetchSessionFromApi} from './session-api';
import {
    resolveFetchSession,
    failFetchSession,
    addHackyDOMUser,
    fetchUserFromDOMAsAHackToQuicklyUpdateOurSession,
} from './session-actions';
// @ts-ignore
import {ActionTypes, SessionAction} from './session-types';

// This needs to be a constructor, so we can provide a custom fetch service in the gmail extension,
// which cannot hit the api directly, but rather has to get passed through the background.js script.
export const makeFetchSessionEpic =
    (fetchSession: () => Promise<UsersApiResponse>) =>
    (action$: ActionsObservable<SessionAction>) =>
        action$.ofType(ActionTypes.SESSION_FETCH_SESSION_REQUEST).pipe(
            switchMap(() => {
                // Return two observable streams of actions, one for the hacky dom session grabbing
                // when we are on the web, and the other for normal `session` api requests
                return Observable.merge(
                    Observable.from(fetchUserFromDOMAsAHackToQuicklyUpdateOurSession()).pipe(
                        map((response) => addHackyDOMUser(response))
                    ),
                    Observable.from(fetchSession()).pipe(
                        map((response: UsersApiResponse) => resolveFetchSession(response)),
                        catchError((error) => Observable.of(failFetchSession(error)))
                    )
                );
            })
        );

export const fetchSessionEpic = makeFetchSessionEpic(fetchSessionFromApi);
